import { AddNewWorkspaceConnectionsViewProps } from "src/components/views/workspaces/workspaceConnections/connectionTypes/WorkspaceConnectedItemTypeConfiguration.ts";
import { ServerSideDataGridModel } from "src/components/common/dataGrid/gridModel/ServerSideDataGridModel.tsx";
import { ProductChangeRequestQueryApi } from "src/api/generated/erp/productChanges/api/productChangeRequestQueryApi.ts";
import { AavoDataGrid } from "src/components/common/dataGrid/AavoDataGrid.tsx";
import { ProductChangeRequestView } from "src/api/generated/erp/db/types/tables/productChangeRequestView.ts";
import { enumColumn, integerColumn, textColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { AavoTextField } from "src/components/common/inputFields/AavoTextField.tsx";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { faLink } from "@fortawesome/pro-regular-svg-icons";
import { WorkspaceConnectionsApi } from "src/api/generated/workspaces/api/workspaceConnectionsApi.ts";
import { getProductChangeRequestStateLabels } from "src/api/generated/erp/db/types/enums/productChangeRequestState.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const ConnectProductChangeRequestsToWorkspaceDataGrid = ({
	workspaceId,
	onCompleted,
}: AddNewWorkspaceConnectionsViewProps) => {
	return (
		<ServerSideDataGridModel
			gridId={"2B7B0D7D5D6B88A6"}
			initialParams={{
				searchQuery: "",
			}}
			fetchData={(params) =>
				ProductChangeRequestQueryApi.getProductChangeRequestsGridData({
					categoryId: null,
					responsiblePersonId: null,
					showCancelled: true,
					showShelved: true,
					searchQuery: params.searchQuery,
					dataModelRequest: params.dataModelRequest,
				})
			}
			getDataModelResult={(data) => data.requests}
			getRowId={(row) => row.productChangeRequestId}
			render={({ refreshData, dataGridProps, selectedRows }) => (
				<AavoDataGrid<ProductChangeRequestView>
					columns={[
						integerColumn({ field: "productChangeRequestId", headerName: i18n.t("id"), width: 80 }),
						textColumn({ field: "title", headerName: i18n.t("title"), width: 250 }),
						textColumn({ field: "categoryName", headerName: i18n.t("category"), width: 160 }),
						enumColumn({
							field: "state",
							headerName: i18n.t("state"),
							enumLabels: getProductChangeRequestStateLabels(),
							width: 180,
						}),
					]}
					actionBarComponents={
						<>
							<AavoTextField
								label={i18n.t("search")}
								onSubmit={async (value) => {
									await refreshData({ searchQuery: value });
								}}
							/>
							<AsyncButton
								icon={faLink}
								label={i18n.t("connect")}
								variant={"outlined"}
								disabled={selectedRows.length === 0}
								onClick={async () => {
									await WorkspaceConnectionsApi.insertConnections({
										workspaceId,
										connectedItemIds: selectedRows.map((r) => r.productChangeRequestId),
										connectedItemType: "PRODUCT_CHANGE_REQUEST",
									});
									await onCompleted();
								}}
							/>
						</>
					}
					agentContext={{
						key: defineAgentUiContextKey("workspaces.connectProductChangeRequests.grid"),
						data: {
							workspaceId: workspaceId,
						},
						rowFields: ["productChangeRequestId", "productChangeId", "title", "state"],
						selectedRowPathSegment: (row) => String(row.productChangeRequestId),
						selectedRowsPathSegment: (count) => i18n.t("product_change_requests_selected_count", { count }),
					}}
					{...dataGridProps}
				/>
			)}
		/>
	);
};
